import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import styled from 'styled-components';
import reactHtmlParser from 'react-html-parser';
import styles from './crew.css';

const PersonWrapper = styled.div`
  display: inline-block;
  flex-shrink: 0;
  outline: none;
  position: relative;
  bottom: 0;
  min-width: 17.9vh;
  width: auto;

  max-height: 750px;
  z-index: ${({ active, zIndex }) => (active ? '10' : zIndex)};
  height: 64vh;
  @media (min-width: 1280px) {
    height: 88vh;
  }
  margin-left: ${({ negativeMargin }) => `${negativeMargin}vh`};
  -webkit-perspective: 0;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  visibility: visible;
  backface-visibility: hidden;

  & *,
  & *::before,
  & *::after {
    -webkit-perspective: 0;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    visibility: visible;
    backface-visibility: hidden;
  }
`;

const PersonImage = styled.img`
  max-height: 100%;
  display: block;
  transition: filter 0.3s ease;
  user-select: none;
`;

const Name = styled.span`
  padding: 0.2rem;
  padding-right: 0;
  padding-left: 0;

  -webkit-box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
  -ms-box-decoration-break: clone;
  -o-box-decoration-break: clone;
  box-decoration-break: clone;
  background-color: #fff;
  color: #2a3547;
  box-shadow: 0.4rem 0 0 #fff, -0.4rem 0 0 #fff;
  font-weight: 300;
  font-size: 1.714rem;
  line-height: 1.41;
  @media (min-width: 768px) {
    font-size: 1.35rem;
  }
`;

const Job = styled.span`
  padding: 0.1rem;

  padding-right: 0;
  padding-left: 0;
  -webkit-box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
  -ms-box-decoration-break: clone;
  -o-box-decoration-break: clone;
  box-decoration-break: clone;
  background-color: #fff;
  color: #df1f3e;
  box-shadow: 0.4rem 0 0 #fff, -0.4rem 0 0 #fff;
  font-weight: 700;
  font-size: 1.0625rem;
  line-height: 1.35;
  @media (min-width: 768px) {
    font-size: 0.85rem;
  }
`;

class Person extends React.Component {
  state = {
    isVisible: false,
  };

  componentDidMount() {
    this.container = document.getElementById('crew-wrapper');
  }

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.setState({ isVisible });
    }
  };

  render() {
    const {
      src,
      name,
      zIndex,
      active,
      setActive,
      setInactive,
      position,
      job,
      className,
      index,
    } = this.props;

    const { isVisible } = this.state;
    return (
      <PersonWrapper
        className={className}
        onMouseLeave={setInactive}
        onMouseEnter={setActive}
        onClick={setActive}
        onBlur={setInactive}
        position={position}
        zIndex={zIndex}
        active={active}
        tabIndex={0}
        negativeMargin={position.desktop}
      >
        <VisibilitySensor
          scrollThrottle={100}
          containment={this.container}
          onChange={this.onVisibilityChange}
          minTopValue={10}
          partialVisibility
          offset={{ left: -800, right: -400, top: -3000 }}
        >
          <div className={styles.sensor} />
        </VisibilitySensor>
        {(isVisible || index < 10) && (
          <PersonImage active={active} src={src} alt={name} />
        )}
        <div
          className={
            active ? styles.annotationWrapperActive : styles.annotationWrapper
          }
        >
          <Name>{reactHtmlParser(name)}</Name>
          <div style={{ marginBottom: '24px' }} />
          <Job>{reactHtmlParser(job)}</Job>
        </div>
      </PersonWrapper>
    );
  }
}

export default Person;



// WEBPACK FOOTER //
// ./src/components/modules/Crew/Person.js